import React from "react";
import { ReactComponent as BackIcon } from "../../../../../assets/utils/images/svgs/arrow-left.svg";
import { Button, CardFooter } from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";

export default function Footer() {
	const { setActiveTab, setFilterCommunity, filterCommunity, adminCommunityList, userTabs } =
		useGebruikerContext();
	return (
		<div className="chat-layout-footer w-100">
			<CardFooter className="chat-layout-footer__inner gebruikers-footer">
				<div className="d-flex justify-content-between w-100">
					<select
						className={`form-select w-auto`}
						value={filterCommunity[0]?.iCommunityId}
						onChange={(e) => {
							setFilterCommunity(
								adminCommunityList.filter(
									(item) => item?.iCommunityId === Number(e.target.value)
								)
							);
						}}
					>
						<option value={""} disabled>
							Alle besturen
						</option>
						{adminCommunityList.map((item) => {
							return (
								<option value={item.iCommunityId} key={item.iCommunityId}>
									{item.vCommunityName}
								</option>
							);
						})}
					</select>
					<Button
						outline
						className="btn-outline-primary-blue ms-auto"
						onClick={() => {
							setActiveTab(userTabs.Documenten);
						}}
						type="button"
						color="primary"
					>
						<BackIcon />
					</Button>
				</div>
			</CardFooter>
		</div>
	);
}
